import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectDetailService} from '../object-detail.service';
import {LibraryList} from './library-list/library-list.model';
import {AppConfigService} from '../../../config/app-config.service';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {BingMapMarker} from '../../../bing-maps/bing-map-marker';
import {BingMapService} from '../../../bing-maps/service/bing-map.service';
import {TranslateService} from "../../../shared/translate.service";
import {Library} from './library-list/library.model';
import {HtmlUtilsService} from '../../../html-utils/html-utils.service';
import {Subscription} from "rxjs";
import {FacetService} from '../../../shared/list/facets/facet.service';
import {FiltersConfig} from '../../../config/filters/filters-config.model';
import {SearchRequest} from '../../search-request.model';
import {FiltersService} from '../../search-list/filters/filters.service';
import {SearchService} from '../../search.service';
import {ListService} from '../../../shared/list/list.service';
import {QueryParams} from '../../../shared/list/query-params.model';
import {UserPositionService} from "../../../bing-maps/service/user-position.service";
import {SearchList} from '../../search-list/search-list';

@Component({
  selector: 'app-bottom-list',
  templateUrl: './bottom-list.component.html',
  styleUrls: ['./bottom-list.component.css']
})
export class BottomListComponent implements OnInit, OnDestroy, OnChanges {

  private matIdsInit: number[] = [];
  private matIdsReady: boolean = false;

  @Input() matIds$: BehaviorSubject<number[]>;

  @Input() showMaterialization: boolean;

  @Input() showFilters: boolean = false;

  @Input() materializations: any[];

  @Input() workType: any;

  @Input() showLibraryTab = false;

  @Input() materView = false;

  @Input() showLibraryFilters = true;

  @Input() type: string;

  @Input() workId: string;

  @Input() nlpId: string;

  @Input() workTitleOfOrigPref: string;

  @Input() creator: string;

  itemCount: number = 0;

  matIds: number[] = [];

  @Input('libList') libraryList: LibraryList;

  articleList: SearchList;

  topicList: SearchList;

  libraryMarkers: BingMapMarker[] = [];

  chosenList: string = 'library';

  selectionLibsList = true;

  selectionFiltersList = false;

  shouldShowMap = false;

  filtersActive: boolean = false;

  sortActive: boolean = false;

  private positionSubsc: Subscription;

  private libarySubscription: Subscription;

  private matIdsSubscription: Subscription;

  private articleSubscription: Subscription;

  private topicSubscription: Subscription;

  private articleSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  private topicSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  mobileVersion = false;

  private mobileVersionSubscription: Subscription;

  private facetUrlChangeSubscription: Subscription;

  private lastUserPoint: any;

  private dataInitialized: boolean = false;

  private facetsConfig;

  private articleFacets;

  private topicFacets;

  private matFacets;

  constructor(private objectDetailsService: ObjectDetailService,
    private appConfig: AppConfigService,
    private mapsService: BingMapService,
    private positionService: UserPositionService,
    private translateService: TranslateService,
    private htmlUtils: HtmlUtilsService,
    private searchService: SearchService,
    private facetService: FacetService,
    private listService: ListService) {
  }

  ngOnInit() {
    this.shouldShowMap = false;
    if (this.materializations && this.materializations.length > 0 ) this.showMaterialization = true;
    this.lastUserPoint = undefined;
    this.initWithoutSubscription();
    this.initSubscriptions();
    this.initChooseList();
    this.initArticleList();
    this.initTopicList();
    this.topicSub$.next({ pageNumber: 0, pageSize: 10, queryParams: null });

    this.facetsConfig = new FiltersConfig({});
    this.facetsConfig.filtersConfig = this.appConfig.workConfig.filtersConfig;
    this.facetService.facetsConfig = this.facetsConfig;



    this.facetUrlChangeSubscription = this.listService.urlChangeEvent.subscribe((queryParams: QueryParams) => {
      if (this.chosenList === 'mat' || this.chosenList === 'library') {
        const idsString = [];
        this.matIdsInit.forEach(id => idsString.push(id+''));
        let searchRequest = new SearchRequest({
          phrase: '',
          page: 0,
          pageSize: 1000,
          materialization: true,
          ids: idsString,
          filter: queryParams.filters
        });
        const aggregates = FiltersService.getAggregate(this.appConfig.workConfig.filtersConfig);
        this.searchService
          .findAll(searchRequest, aggregates)
          .subscribe(result => {
            const search = result.search;
            if (search) {
              this.materializations = search;
              this.matIds$.next(search.map(item => item['id']));
              this.matFacets = result;
              this.consumeFacets(this.matFacets);
            }
          });
      } else if(this.chosenList === 'topics') {
        this.topicSub$.next({ pageNumber: 0, pageSize: 10, queryParams: queryParams });
      } else {
        this.articleSub$.next({ pageNumber: 0, pageSize: 10, queryParams: queryParams });
      }
    });

    const initSubscription = this.matIds$.subscribe(ids => {
      if (!this.matIdsReady && ids.length > 0) {
        this.matIdsReady = true;
        this.matIdsInit = ids;
        const idsString = [];
        ids.forEach(id => idsString.push(id+''));
        this.listService.matIds.next(idsString);
        let searchRequest = new SearchRequest({
          phrase: '',
          page: 0,
          pageSize: 1000,
          materialization: true,
          ids: idsString,
          filter: '_type:materialization'
        });
        const aggregates = FiltersService.getAggregate(this.appConfig.workConfig.filtersConfig);
        this.searchService
          .findAll(searchRequest, aggregates)
          .subscribe(result => {
            this.matFacets = result;
            this.consumeFacets(this.matFacets);
          });
          if(initSubscription != null && initSubscription != undefined)
            initSubscription.unsubscribe();
      }
    });

  }

  ngOnDestroy(): void {
    this.listService.matIds.next([]);
    this.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.workId) {
      this.chosenList = 'library';

    }
    if(changes.nlpId){
      this.nlpId = changes.nlpId.currentValue;
      this.articleSub$.next({ pageNumber: 0, pageSize: 10, queryParams: null });
      this.topicSub$.next({ pageNumber: 0, pageSize: 10, queryParams: null });
    }
    this.shouldShowMap = true;
  }

  private consumeFacets(facets) {
    this.facetService.consumeFacets(facets);
  }

  private initData(ids, userPoint, mobileVersion: boolean) {
    if (ids && ids.length > 0) {
      if ((mobileVersion && (!BottomListComponent.isEqual(this.lastUserPoint, userPoint)
          || (BottomListComponent.isEqual(this.lastUserPoint, userPoint) && !this.dataInitialized)))
        || !mobileVersion) {
          this.libarySubscription = this.objectDetailsService.getLibrariesWork(ids, userPoint).subscribe((data: any) => {
            this.libraryList = new LibraryList(data);
            this.dataInitialized = true;
            this.initChooseList();
            this.initLibraryData();
          });
      }
    } else {
      this.dataInitialized = false;
    }
  }

  private initLibraryData(): void {
    this.mapsService.clearPushpins();
    if (this.libraryList && this.libraryList.libraries) {
      const libraryMarkers = [];
      let index = 0;
      this.libraryList.libraries.forEach((lib: Library) => {
        if (lib.lat && lib.lat !== null && lib.lon && lib.lon !== null) {
          let tempIndex = !lib.online ? ++index : -1;
          libraryMarkers.push(lib.toBingMapMarker('' + tempIndex));
        }
      });
      this.libraryMarkers = libraryMarkers;
    }
  }

  private initWithoutSubscription() {
    this.dataInitialized = false;
    this.mobileVersion = this.htmlUtils.mobileVersion;
    this.initData(this.matIds, this.lastUserPoint, this.mobileVersion);
  }

  private initSubscriptions() {

    if (!this.mobileVersionSubscription) {
      this.mobileVersionSubscription = this.htmlUtils.mobileBehaviorSubject.subscribe(mobileVersion => {
        //trigger only on changes
        if (this.mobileVersion !== mobileVersion) {
          this.mobileVersion = mobileVersion;
          /*this.lastUserPoint = undefined;*/
          this.initData(this.matIds, this.lastUserPoint, this.mobileVersion);
        }
      });
    }
    if (!this.matIdsSubscription) {
      this.matIdsSubscription = this.matIds$.subscribe(value => {
        //it should be not empty
        if (value && value.length > 0) {
          this.mapsService.clearDirections();
          this.matIds = value;
          this.initData(this.matIds, this.lastUserPoint, this.mobileVersion);
          if (this.positionSubsc) {
            this.positionSubsc.unsubscribe();
          }
          this.positionSubsc = this.positionService.positionEmitter.subscribe((userPoint) => {
            if(userPoint && !this.lastUserPoint) {
              this.initData(value, userPoint, this.mobileVersion);
              this.lastUserPoint = userPoint;
            }
          });
        } else {
          this.initChooseList();
        }
      });
    }
  }

  private initChooseList() {
    if (this.libraryList && this.libraryList.count > 0) {
      this.showLibraryTab = true;
    } else {
      this.showLibraryTab = false;
    }
  }

  private initArticleList() {
    this.articleSubscription = this.articleSub$.subscribe(params => {
      if ( params !== null ) {
        let searchRequest = new SearchRequest({
          phrase: '',
          // tslint:disable-next-line:radix
          page: parseInt(params.pageNumber),
          // tslint:disable-next-line:radix
          pageSize: parseInt(params.pageSize),
          materialization: false
        });
        if (params.queryParams) {
          searchRequest.filter = params.queryParams.filters;
        } else {
          searchRequest.filter = '_type:work,work_host_item_nlp_id:' + this.nlpId;
        }
        const aggregates = FiltersService.getAggregate(this.appConfig.workConfig.articlesConfig);
        this.searchService
          .findAll(searchRequest, aggregates)
          .subscribe(result => {
            this.articleFacets = result;
            this.consumeFacets(this.articleFacets);
            this.articleList = new SearchList(result, 100);
            console.log(this.articleList)
          });
      }
    });
  }

  private initTopicList() {
    this.topicSubscription = this.topicSub$.subscribe(params => {
      if ( params !== null && this.workTitleOfOrigPref && this.creator) {
        let searchRequest = new SearchRequest({
          phrase: '',
          // tslint:disable-next-line:radix
          page: parseInt(params.pageNumber),
          // tslint:disable-next-line:radix
          pageSize: parseInt(params.pageSize),
          materialization: false
        });
        if (params.queryParams) {
          searchRequest.filter = params.queryParams.filters;
        } else {
          searchRequest.filter = '_type:work,work_subject_work.title:`' + this.workTitleOfOrigPref
            + '`, work_subject_work.creator:`' + this.creator + '`';
        }
        const aggregates = FiltersService.getAggregate(this.appConfig.workConfig.topicsConfig);
        this.searchService
          .findAll(searchRequest, aggregates)
          .subscribe(result => {
            this.topicFacets = result;
            this.consumeFacets(this.topicFacets);
            this.topicList = new SearchList(result, 100);
          });
      }
    });
  }

  libraryChosen() {
    this.chosenList = 'library';
    this.facetsConfig = new FiltersConfig({});
    this.facetsConfig.filtersConfig = this.appConfig.workConfig.filtersConfig;
    this.facetService.facetsConfig = this.facetsConfig;
    this.consumeFacets(this.matFacets);
  }

  matListChosen() {
    this.chosenList = 'mat';
    this.facetsConfig = new FiltersConfig({});
    this.facetsConfig.filtersConfig = this.appConfig.workConfig.filtersConfig;
    this.facetService.facetsConfig = this.facetsConfig;
    this.consumeFacets(this.matFacets);
  }

  articlesChosen() {
    this.chosenList = 'articles';
    this.facetsConfig = new FiltersConfig({});
    this.facetsConfig.filtersConfig = this.appConfig.workConfig.articlesConfig;
    this.facetService.facetsConfig = this.facetsConfig;
    this.consumeFacets(this.articleFacets);
  }

  topicsChosen() {
    this.chosenList = 'topics';
    this.facetsConfig = new FiltersConfig({});
    this.facetsConfig.filtersConfig = this.appConfig.workConfig.topicsConfig;
    this.facetService.facetsConfig = this.facetsConfig;
    this.consumeFacets(this.topicFacets);
  }

  getMatName() {
    let output = this.translateService.translate('bottom-list.materializations-list');
    if (!this.workType) {
      return output;
    }
    this.workType.forEach(value => {
      if (value.value === 'Książki') {
        output = this.translateService.translate('bottom-list.materializations');
      }
    });
    return output;
  }

  setItemCount(value: number) {
    this.itemCount = value;
  }

  private static isEqual(b1: BingMapMarker, b2: BingMapMarker) {
    if (b1 && b2) {
      return b1.lon === b2.lon && b1.lat === b2.lat;
    }
    else {
      return b1 === b2;
    }
  }

  private unsubscribe() {
    if (this.matIdsSubscription) {
      this.matIdsSubscription.unsubscribe();
    }
    if (this.positionSubsc) {
      this.positionSubsc.unsubscribe();
    }
    if (this.mobileVersionSubscription) {
      this.mobileVersionSubscription.unsubscribe();
    }
    if (this.libarySubscription) {
      this.libarySubscription.unsubscribe();
    }
    if (this.facetUrlChangeSubscription) {
      this.facetUrlChangeSubscription.unsubscribe();
    }
    if (this.articleSubscription) {
      this.articleSubscription.unsubscribe();
    }
    if (this.topicSubscription) {
      this.topicSubscription.unsubscribe();
    }
  }

  libBlockChanged(isOpen: boolean) {
    /*if (isOpen) {
      this.selectionFiltersList = false;
    }
    this.selectionLibsList = isOpen;*/
  }

  facetBlockChanged(isOpen: boolean) {
    /*if (isOpen) {
      this.selectionLibsList = false;
    }
    this.selectionFiltersList = isOpen;*/
  }

  updateSelectionFilter(value: boolean) {
    this.selectionFiltersList = value;
  }

  updateSelectionLib(value: boolean){
    this.selectionLibsList = value;
  }

  toggleFilter() {
    this.showFilters = !this.showFilters;
  }

  appendNewArticles(params) {
     this.articleSub$.next(params);
  }

  appendNewTopics(params) {
    this.topicSub$.next(params);
  }

  hideFiltersLabel() {
    return this.translateService.translate('filters.label');
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
    if (this.sortActive) {
      this.sortActive = false;
    }
  }

  toggleSort() {
    this.sortActive = !this.sortActive;
    if (this.showFilters) {
      this.showFilters = false;
    }
  }
}
